import { durationInDays, formatDate } from "@/modules/carga-trabalho";
import type { CargaTrabalhoIntervalo } from "@/modules/carga-trabalho";
import type { Profissional } from "@/modules/recursos";
import { textoDaObra } from "@/shared/utils/formatar-identificacao-obra";
import type { ProfissionalOpcao } from "./equipe-obra.types";

/** `88 - Austral Abrolhos` (ADR 0018); sem embarcação no dado, `88 - P. Feiticeiras`. */
export const obraLabel = textoDaObra;

/** `1 Conflito` / `N Conflitos` (Figma 9141:352541 e 9129:353328). */
export const rotuloConflitos = (quantidade: number) =>
  `${quantidade} ${quantidade === 1 ? "Conflito" : "Conflitos"}`;

/** `10/03/2030 a 20/09/2030`. */
export function formatPeriodo(intervalo: CargaTrabalhoIntervalo): string {
  return `${formatDate(intervalo.inicio)} a ${formatDate(intervalo.fim)}`;
}

/** `5 dias (12/06/2030 a 16/06/2030)`. */
export function descreverCoincidencia(intervalo: CargaTrabalhoIntervalo): string {
  const dias = durationInDays(intervalo);
  return `${dias} ${dias === 1 ? "dia" : "dias"} (${formatPeriodo(intervalo)})`;
}

/** `Profissional` da listagem no formato do select: nome (ou e-mail), e-mail e disponibilidade. */
export function opcaoDoProfissional(profissional: Profissional): ProfissionalOpcao {
  return {
    value: profissional.id,
    label: profissional.nome || profissional.email,
    email: profissional.email,
    indisponivel: profissional.indisponibilidade.indisponivel,
  };
}
